'use client'
import React, { Dispatch, SetStateAction, useCallback } from 'react'
import Image from 'next/image'
import styles from '../styles.module.scss'

interface SidebarButtonProps {
  sidebarOpen: boolean
  setSidebarOpen: Dispatch<SetStateAction<boolean>>
  image: string
}

const SidebarButton = ({
  sidebarOpen,
  setSidebarOpen,
  image,
}: SidebarButtonProps) => {
  const onButtonClickHandler = useCallback(() => {
    setSidebarOpen(!sidebarOpen)
  }, [sidebarOpen, setSidebarOpen])

  return (
    <button className={styles.button} onClick={onButtonClickHandler}>
      <Image src={image} alt="sidebar" width={14} height={14} />
    </button>
  )
}

export default SidebarButton
